import { useList, useDetail, useCreate, useUpdate, useDelete, useListInfinite, useAction } from "@inmagik/react-crud"
import { HistoricalInfo, Supporto } from "../types"
import { API_URL } from "../constants"

export function useSupportiList(params: Record<string, string | number | string[] | number[]> = {}) {
  return useList<Supporto>(`${API_URL}/supporti`, {
    query: params,
  })
}

export function useSupporto(id: number | undefined | string) {
  return useDetail<Supporto>(`${API_URL}/supporti`, id?.toString())
}

export function useSupportoCreate() {
  return useCreate<Supporto>(`${API_URL}/supporti`)
}

export function useSupportoUpdate() {
  return useUpdate<Supporto>(`${API_URL}/supporti`)
}

export function useSupportoDelete() {
  return useDelete<Supporto>(`${API_URL}/supporti`)
}

export function useSupportoHistory(id: number | string) {
  return useListInfinite<HistoricalInfo>(`${API_URL}/supporti/${id}/history`)
}

export function useSupportoSetAllegati(id: number | string) {
  return useAction(`${API_URL}/supporti/${id}/set-allegati`, {
    method: "POST",
    encode: "formdata",
  })
}

export function useSupportoSetAllegatiImmagine(id: number | string) {
  return useAction(`${API_URL}/supporti/${id}/set-allegati-immagine`, {
    method: "POST",
    encode: "formdata",
  })
}

type DurationRes = {
  duration?: string
}

type DurationReq = {
  lunghezza?: number
  formato?: number
  framerate?: number
}

export function useEstimatedDuration() {
  return useAction<DurationRes, DurationReq>(`${API_URL}/supporti/estimate-duration`, {
    method: "POST",
    encode: "formdata",
  })
}

export function useDownloadSupporti(params: Record<string, string | number | string[] | number[]> = {}) {
  return useAction<Blob, void>(`${API_URL}/supporti/download`, {
    method: "GET",
    query: params,
    responseType: "blob",
  })
}

export type SupportiImportPayload = {
  file: File
  commit: boolean
}

export type SupportiImportResponse = {
  supporti_update: string[],
  supporti_new: string[],
  errors: Record<string, Record<string, string>>
}

export function useSupportiImport() {
  return useAction<SupportiImportResponse, SupportiImportPayload>(`${API_URL}/supporti/import-xlsx`, {
    method: "POST",
    encode: "formdata",
  })
}
